import { AuditClaimSearchParams } from '@module-claims/models/claims-http.interface';

export class ActionAuditClaimSearchClear {
  static readonly type = '[ Audit Claim Search ] Clear Search';
}

export class ActionAuditClaimSearchSubmit {
  static readonly type = '[ Audit Claim Search ] Submit Search';

  constructor(public params: AuditClaimSearchParams) {}
}
